import { FlattenedGadget } from "../models/GadgetModel";
import { GadgetPlaform } from "../pages/Home/components/gadgets/GadgetPlaform";
import { GadgetUrlRequest, Method } from "../pages/Home/components/gadgets/GadgetRepository";
import { DevicePlatform } from "./cloudcore/response/models/body";

declare const genv: any;

export enum FileType {
  ICON = "ICON",
  SNAPSHOT = "SNAPSHOT"
}

export const createResourceEndpointUrl = (
  gadgetId: number,
  version: string,
  platform: string,
  fileType: FileType,
  filename: string
) => {
  let url = new URL(genv.MINIO_ENDPOINT_URL || "");
  url.pathname = [
    url.pathname,
    gadgetId?.toString(),
    platform,
    version,
    fileType.toString(),
    filename,
  ]
    .filter((s) => s && s.length > 0)
    .join("/");
  return url.toString();
};

export const downloadFile = (url: string, fileName: string) => {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

export function debounce<F extends (...args: any[]) => void>(func: F, waitFor: number): (...args: Parameters<F>) => void {
  let timeout: number | undefined;

  return function(...args: Parameters<F>) {
    clearTimeout(timeout);
    timeout = window.setTimeout(() => func(...args), waitFor);
  };
}

export const getGadgetSizeInMB = (gadgetSize: number) => {
  return (gadgetSize/(1024*1024)).toFixed(2);
}

export const getGPKUrl = (displayGadget: FlattenedGadget): GadgetUrlRequest => {
  return {
      version: displayGadget.version,
      method: Method.GET,
      platform: displayGadget.platform
  } as GadgetUrlRequest;
}

export const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  element && element.scrollIntoView({ behavior: "smooth",  block: "start", });
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const isGadgetSupportedByDevice = (
  gadgetPlatform: GadgetPlaform,
  devicePlatform: DevicePlatform
): boolean => {
  return (
    (gadgetPlatform === GadgetPlaform.WEB) ||
    (gadgetPlatform === GadgetPlaform.WINDOWS && devicePlatform === DevicePlatform.WINDOWS) ||
    (gadgetPlatform === GadgetPlaform.MAC && devicePlatform === DevicePlatform.MAC)
  );
};

export const capitalizeFirstLetter = (input: string): string => {
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
};

export const getFileSize = async (url: string) => {
  try {
      const response = await fetch(url, { method: 'HEAD' });
      
      if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      const fileSize = response.headers.get('Content-Length');
      return fileSize != null ? Math.ceil(parseInt(fileSize)/(1024*1024)) : 0;
  } catch (error) {
      console.error('Failed to fetch file metadata:', error);
  }
}